<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "JALA Cycles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_cycles.plural')) }},
    resourceRoute: {default: 'jala_cycles'},
    modelVariable: {default: 'jala_cycle'}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_cycles.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_cycles.plural')),
          href: "/jala_cycles",
          active: true,
        },
      ],
      filterColumns: {
        name: { type: String, label: this.lodash.upperFirst(this.$t('jala_cycles.name')) },
      }
    }
  },
  computed: {
    columns() {
      return {
        ['jala_cycle']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'farm.name',
            label: this.lodash.upperFirst(this.$t('jala_cycles.farm')),
            thStyle: { minWidth: '150px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/farms/${(item.farm || {}).id}`">{{ lodash.get(item, "farm.name") }}</router-link>'
            }
          },
          {
            key: 'pond.name',
            label: this.lodash.upperFirst(this.$t('jala_cycles.pond')),
            thStyle: { minWidth: '150px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/ponds/${(item.farm || {}).id}`">{{ lodash.get(item, "pond.name") }}</router-link>'
            }
          },
          {
            key: 'started_at',
            label: this.lodash.upperFirst(this.$t('jala_cycles.started_at')),
            thStyle: { minWidth: '150px' },
            class: 'text-center',
            sortable: true,
            component: {
              props: ['item'],
              template: '<div class="text-truncate" :title="item.started_at">{{ $moment(item.started_at).format("DD MMMM YYYY") }}</div>'
            }
          },
          {
            key: 'age',
            label: this.lodash.upperFirst(this.$t('jala_cycles.age')),
            thStyle: { minWidth: '80px' },
            class: 'text-center',
            sortable: true
          },
          {
            key: 'total_seed',
            label: this.lodash.upperFirst(this.$t('jala_cycles.total_seed')),
            thStyle: { minWidth: '110px' },
            class: 'text-end',
            sortable: true,
            formatter: (value) => {
              return this.$numeral(value).format('0,0.[00]')
            }
          },
          { key: 'action', class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      return this.$axios.delete(`/jala/cycles/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/jala/cycles', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          with: 'pond,farm',
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: false
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
